import { ReactNode } from 'react';

import { IClassName } from '../../../../utils';

export enum CardImageMediaTypes {
  Image = 'Image',
  Video = 'Video',
  Carousel = 'Carousel',
}

export enum CardLayout {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
}

export enum CardImagePosition {
  Left = 'Left',
  Right = 'Right',
}

export interface IImage {
  src: string;
  alt: string;
  width?: string;
  height?: string;
}

export interface IVideo {
  src: string;
  type: string;
  width?: string;
  height?: string;
}

export interface ICarouselData {
  image?: IImage;
  video?: IVideo;
  label?: string;
  title: string;
  description: string;
}

export interface ICardImageMedia {
  type: CardImageMediaTypes;
  images?: IImage[];
  videos?: IVideo[];
  carouselData?: ICarouselData[];
}

export default interface ICardImage extends IClassName {
  label?: string;
  title?: string | ReactNode;
  description?: string | ReactNode;
  media: ICardImageMedia;
  layout?: CardLayout;
  imagePosition?: CardImagePosition;
  href?: string;
}
